import {PayloadListModel} from '../../../../../../../../core';
import {SearchEntity} from '../entity/search.models';

export class LoadPayload extends PayloadListModel<SearchEntity> {
}
